export const ImgAvatar = ({ alt, src, square, styles }) => (
  <img
    alt={alt}
    src={src}
    className={`object-cover ${styles && styles} ${
      square ? "rounded-xl w-12 h-12" : "rounded-full w-8 h-8"
    } `}
  />
)
